import { WidgetEnv } from "@xapp/stentor-chat-widget";
import React, { FC, useMemo } from "react";
import { Provider } from "react-redux";
import { ChatState } from "../../store/ChatState";
import { createStaticStore } from "../../store/StaticStore";
import ChatWidget, { ChatWidgetMode } from "./ChatWidget";

export interface StaticChatWidgetContainerProps {
    readonly state?: ChatState;
    readonly mode?: ChatWidgetMode;
    readonly config: Omit<WidgetEnv, "connection">;
}

const StaticChatWidgetContainer: FC<StaticChatWidgetContainerProps> = props => {

    const { state } = props;

    const store = useMemo(() => {
        return createStaticStore(state);
    }, [state]);

    const config = useMemo<WidgetEnv>(() => {
        return {
            ...props.config,
            connection: {
                serverUrl: "",
                type: "local"
            }
        };
    }, [props.config]);

    return (
        <Provider store={store}>
            <ChatWidget
                {...props}
                config={config}
            />
        </Provider>
    );
}

export default StaticChatWidgetContainer;